var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { throwError as observableThrowError, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CommonMethods } from '../../../job/common/tools/commonMethods';
import { ToolArgs, ToolKeyValue, ToolApiResponse, ToolApiDatasReturn, ToolsApisType, ToolApi, ToolApiConnect, ToolService, ToolApiEntity, ToolApiReturn, ToolApiMatchingValuesApp } from '../../../models/common.model';
import { WksBusinessModel } from '../models/wks-business.model';
import { WksCentralService } from './wks-central.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./wks-central.service";
export class WksApisService {
    constructor(httpClient, _wksCentralService) {
        this.httpClient = httpClient;
        this._wksCentralService = _wksCentralService;
    }
    setHeaders(_headers) {
        this.httpHeaders = _headers;
    }
    settingAPIS(APIS_args) {
        this.APIS = APIS_args;
    }
    getApisParam(apiNameArg) {
        const apisList = this.APIS;
        let apiCur;
        for (const apiParam of apisList) {
            if (apiParam.apiName === apiNameArg) {
                apiCur = apiParam.apiTools;
            }
        }
        return apiCur;
    }
    getApisMatchingValues(apiNameArg) {
        const apisList = this.APIS;
        let apiMatchingValuesApp;
        for (const apiParam of apisList) {
            if (apiParam.apiName === apiNameArg) {
                apiMatchingValuesApp = apiParam.apiMatchingValuesApp;
            }
        }
        return apiMatchingValuesApp;
    }
    setApisEntity(apisEntity) {
        if (apisEntity !== undefined) {
            for (const apiCur of apisEntity) {
                if (apiCur.apiName === 'stockManagement') {
                    this.stockManagementApi = apiCur.apiTool;
                    if (this.stockManagementApi === undefined || this.stockManagementApi.toolName === undefined) {
                        this.stockManagementApi = undefined;
                    }
                }
                else if (apiCur.apiName === 'accounting') {
                    this.accountingApi = apiCur.apiTool;
                    if (this.accountingApi === undefined || this.accountingApi.toolName === undefined) {
                        this.accountingApi = undefined;
                    }
                }
                else if (apiCur.apiName === 'notifications') {
                    this.notificationsApi = apiCur.apiTool;
                    if (this.notificationsApi === undefined || this.notificationsApi.toolName === undefined) {
                        this.notificationsApi = undefined;
                    }
                }
                else if (apiCur.apiName === 'customers') {
                    this.customersApi = apiCur.apiTool;
                    if (this.customersApi === undefined || this.customersApi.toolName === undefined) {
                        this.customersApi = undefined;
                    }
                }
                else if (apiCur.apiName === 'quotation') {
                    this.quotationApi = apiCur.apiTool;
                    if (this.quotationApi === undefined || this.quotationApi.toolName === undefined) {
                        this.quotationApi = undefined;
                    }
                }
                else if (apiCur.apiName === 'invoicing') {
                    this.invoicingApi = apiCur.apiTool;
                    if (this.invoicingApi === undefined || this.invoicingApi.toolName === undefined) {
                        this.invoicingApi = undefined;
                    }
                }
            }
        }
    }
    getApiStockManagement() {
        return this.stockManagementApi;
    }
    getServicesStockManagement() {
        let toolServices;
        const apisDef = this.getApisParam('stockManagement');
        if (apisDef === undefined || apisDef === null) {
            return toolServices;
        }
        let toolApiCur;
        for (const apisDefItem of apisDef) {
            if (apisDefItem.toolName === this.stockManagementApi.toolName) {
                toolApiCur = apisDefItem;
                break;
            }
        }
        for (const toolVersionItem of toolApiCur.toolVersions) {
            if (toolVersionItem.toolVersion === this.stockManagementApi.toolVersion) {
                toolServices = toolVersionItem.toolServices;
            }
        }
        return toolServices;
    }
    getApiServices(apiName, apiConnect) {
        let toolServices = [];
        const apisDef = this.getApisParam(apiName);
        if (apisDef === undefined || apisDef === null) { // no api defined
            return toolServices;
        }
        let toolApiCur;
        for (const apisDefItem of apisDef) {
            if (apisDefItem.toolName === apiConnect.toolName) {
                toolApiCur = apisDefItem;
                break;
            }
        }
        if (toolApiCur === undefined || toolApiCur === null) { // no api name defined
            return toolServices;
        }
        for (const toolVersionItem of toolApiCur.toolVersions) {
            if (toolVersionItem.toolVersion === apiConnect.toolVersion) {
                toolServices = toolVersionItem.toolServices;
            }
        }
        return toolServices;
    }
    getApiAccounting() {
        // const apisDef = this.getApisParam('accounting');
        return this.accountingApi;
    }
    getApiNotifications() {
        // const apisDef = this.getApisParam('notifications');
        return this.notificationsApi;
    }
    getApiCustomers() {
        // const apisDef = this.getApisParam('customers');
        return this.customersApi;
    }
    getApiinvoicing() {
        // const apisDef = this.getApisParam('invoicing');
        return this.invoicingApi;
    }
    getApiQuotation() {
        // const apisDef = this.getApisParam('invoicing');
        return this.quotationApi;
    }
    isAPiActive(apiName, apiServiceName) {
        let isActive = false;
        let apiConnect;
        // reading connect api entity
        switch (apiName) {
            case 'stockManagement': {
                apiConnect = this.getApiStockManagement();
                break;
            }
            case 'accounting': {
                apiConnect = this.getApiAccounting();
                break;
            }
            case 'notifications': {
                apiConnect = this.getApiNotifications();
                break;
            }
            case 'customers': {
                apiConnect = this.getApiCustomers();
                break;
            }
            case 'invoicing': {
                apiConnect = this.getApiinvoicing();
                break;
            }
        } // end switch
        if (apiConnect === undefined || apiConnect === null) { // no api connect in entity profile
            isActive = false;
            return isActive;
        }
        // reading services for apiName and apiConnect
        const toolServices = this.getApiServices(apiName, apiConnect);
        if (toolServices === undefined || toolServices === null) { // no services actived for Api connect
            isActive = false;
            return isActive;
        }
        // reading service
        for (const serviceItem of toolServices) {
            if (serviceItem.name === apiServiceName) {
                isActive = true;
                break;
            }
        }
        return isActive;
    }
    readStockByRef(brandRef, stdEntity) {
        const apiService = 'stockByRef';
        const apiName = 'stockManagement';
        const toolArgs = {
            toolDatas: []
        };
        let testData = {
            key: 'toolCustomerNwsCode',
            value: this.getApiStockManagement().toolCustomerNwsCode
        };
        toolArgs.toolDatas.push(testData);
        testData = {
            key: 'toolCustomerNwsId',
            value: this.getApiStockManagement().toolCustomerNwsId
        };
        toolArgs.toolDatas.push(testData);
        const toolKeyValue = {
            key: 'brandRef',
            value: brandRef,
            listValues: undefined,
            arrayValues: undefined
        };
        const jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
        this.requestApis(stdEntity, apiName, apiService, toolArgs)
            .subscribe((data) => {
            const toolApiResponse = data.body;
            if (toolApiResponse.statut === 'KO') {
                const itemResponse = toolApiResponse.toolDatas[0];
                if (itemResponse.value === '404') {
                    toolApiResponse.toolDatas.push({
                        key: 'nws_stock_qty',
                        value: '0.0'
                    });
                }
                return this.affectResponseStock(toolApiResponse);
            }
            else {
                return this.affectResponseStock(toolApiResponse);
            }
        }, err => {
            console.log(' readStockByRef : ' + JSON.stringify(err));
            return undefined;
        });
        return undefined;
    }
    affectResponseStock(toolApiResponse) {
        const toolApiDatasReturn = {
            // datas: ToolApiReturn[];
            datas: []
        };
        // const itemResponse = toolApiResponse.toolDatas[0];
        let itemValue = '';
        for (const itemCur of toolApiResponse.toolDatas) {
            if (itemCur.key === 'nws_stock_qty') {
                itemValue = itemCur.value;
                const toolApiReturn = {
                    dataName: 'nws_stock_qty',
                    dataValue: parseFloat(itemValue)
                };
                toolApiDatasReturn.datas.push(toolApiReturn);
            }
            if (itemCur.key === 'nws_stock_id') {
                const toolApiReturn = {
                    dataName: 'nws_stock_id',
                    dataValue: itemCur.value
                };
                toolApiDatasReturn.datas.push(toolApiReturn);
            }
        }
        return toolApiDatasReturn;
    }
    /*
    registerStockProduct(partSupplie: ParamPartsSuppliesModel, stockStatut: string): ToolApiResponse {
  
      let apiService = '';
  
      if (stockStatut === undefined) {
        return;
      }
      if (stockStatut === 'toCreate') {
        apiService = 'create';
      }
      if (stockStatut === 'toUpdate') {
         apiService = 'update';
      }
      const apiName = 'stockManagement';
      const otherData = JSON.parse(partSupplie.otherData) as ParamOtherData;
  
      const toolArgs: ToolArgs = {
        toolDatas: []
      };
      let testData = {
        key: 'toolCustomerNwsCode',
        value: this.getApiStockManagement().toolCustomerNwsCode
      };
      toolArgs.toolDatas.push(testData);
      testData = {
        key: 'toolCustomerNwsId',
        value: this.getApiStockManagement().toolCustomerNwsId
      };
      toolArgs.toolDatas.push(testData);
  
      let toolKeyValue: ToolKeyValue = {
        key: 'nws_label',
        value: partSupplie.paramLabel,
        listValues: undefined,
        arrayValues: undefined
      };
      let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
  
      if (apiService === 'update') {
        toolKeyValue = {
          key: 'nws_stock_id',
          value: otherData.externalId,
          listValues: undefined,
          arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
      }
  
      toolKeyValue = {
        key: 'brandRef',
        value: partSupplie.brandRef,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
  
      toolKeyValue = {
        key: 'nws_barcodeType',
        value: otherData.barcodeType,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
  
      toolKeyValue = {
        key: 'nws_barcode',
        value: partSupplie.brandBarcode,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
  
      toolKeyValue = {
        key: 'brandName',
        value: partSupplie.brandName,
        listValues: undefined,
        arrayValues: undefined
      };
      jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
      toolArgs.toolDatas.push(jsonTmp);
      
      if (partSupplie.paramRate !== undefined) {
        toolKeyValue = {
          key: 'nws_stock_price',
          value: '' + partSupplie.paramRate.toString(),
          listValues: undefined,
          arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
      }
  
      await this.requestApis(partSupplie.stdEntity, apiName, apiService, toolArgs )
      .subscribe(
        (data: any) => {
  
          const toolApiResponse = data.body as ToolApiResponse;
          if (toolApiResponse.statut === 'KO') {
  
          } else  {
            // const nwsId =  toolApiResponse.toolDatas[0].value;
            return data.body as ToolApiResponse;
            
          }
        },
        err => {
  
        }
      );
  
    }
    */
    registerStockProduct(partSupplie, stockStatut) {
        return __awaiter(this, void 0, void 0, function* () {
            let apiService = '';
            if (stockStatut === undefined) {
                return;
            }
            if (stockStatut === 'toCreate') {
                apiService = 'create';
            }
            if (stockStatut === 'toUpdate') {
                apiService = 'update';
            }
            const apiName = 'stockManagement';
            const otherData = JSON.parse(partSupplie.otherData);
            const toolArgs = {
                toolDatas: []
            };
            let testData = {
                key: 'toolCustomerNwsCode',
                value: this.getApiStockManagement().toolCustomerNwsCode
            };
            toolArgs.toolDatas.push(testData);
            testData = {
                key: 'toolCustomerNwsId',
                value: this.getApiStockManagement().toolCustomerNwsId
            };
            toolArgs.toolDatas.push(testData);
            let toolKeyValue = {
                key: 'nws_label',
                value: partSupplie.paramLabel,
                listValues: undefined,
                arrayValues: undefined
            };
            let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            if (apiService === 'update') {
                toolKeyValue = {
                    key: 'nws_stock_id',
                    value: otherData.externalId,
                    listValues: undefined,
                    arrayValues: undefined
                };
                jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
                toolArgs.toolDatas.push(jsonTmp);
            }
            toolKeyValue = {
                key: 'brandRef',
                value: partSupplie.brandRef,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'nws_barcodeType',
                value: otherData.barcodeType,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'nws_barcode',
                value: partSupplie.brandBarcode,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            toolKeyValue = {
                key: 'brandName',
                value: partSupplie.brandName,
                listValues: undefined,
                arrayValues: undefined
            };
            jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
            toolArgs.toolDatas.push(jsonTmp);
            if (partSupplie.paramRate !== undefined) {
                toolKeyValue = {
                    key: 'nws_stock_price',
                    value: '' + partSupplie.paramRate.toString(),
                    listValues: undefined,
                    arrayValues: undefined
                };
                jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
                toolArgs.toolDatas.push(jsonTmp);
            }
            try {
                const response = yield this.requestApis(partSupplie.stdEntity, apiName, apiService, toolArgs).toPromise();
                const toolApiResponse = response.body;
                if (toolApiResponse.statut === 'KO') {
                    // gérer l'erreur métier
                    return;
                }
                return toolApiResponse;
            }
            catch (err) {
                // gérer l'erreur HTTP
                console.error(err);
                return;
            }
        });
    }
    // Deprecated
    customersApiService(wksBnsCur, apiService) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiName = 'customers';
            const toolArgs = {
                toolDatas: []
            };
            this.affectToolKeyValue('toolCustomerNwsCode', this.getApiStockManagement().toolCustomerNwsCode, toolArgs);
            this.affectToolKeyValue('toolCustomerNwsId', this.getApiStockManagement().toolCustomerNwsId, toolArgs);
            this.affectDataBsn(wksBnsCur, toolArgs, apiName);
            try {
                const data = yield this.requestApis(wksBnsCur.stdEntity, apiName, apiService, toolArgs).toPromise();
                const toolApiResponse = data.body;
                return this.affectResponseCustomer(toolApiResponse);
            }
            catch (err) {
                console.error('Erreur API', err);
                return undefined;
            }
        });
    }
    // ==================================
    affectDataBsn(wksBnsCur, toolArgs, apiName) {
        const apiMatchingValuesApp = this.getApisMatchingValues(apiName);
        const personValues = [];
        const companyValues = [];
        const addressValues = [];
        const otherDatasValues = [];
        const bsnValues = [];
        const emailsValues = [];
        const phonesValues = [];
        const bnsAccountingValues = [];
        for (const matchingItem of apiMatchingValuesApp) {
            const appValueKey = matchingItem.appValue;
            if (appValueKey.startsWith('bsn')) {
                if (appValueKey.includes('bsnPerson')) {
                    personValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bsnCompany')) {
                    companyValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bsnAddress')) {
                    addressValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bsnOtherdatas')) {
                    otherDatasValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bsnPhones')) {
                    phonesValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bsnEmails')) {
                    emailsValues.push(matchingItem);
                    continue;
                }
                else if (appValueKey.includes('bnsAccounting')) {
                    bnsAccountingValues.push(matchingItem);
                    continue;
                }
                else {
                    bsnValues.push(matchingItem);
                    continue;
                }
            }
        }
        let bsnAddress;
        let bsnEmails;
        let bsnPhones;
        // Bsn
        for (const matchPath of bsnValues) {
            const value = this.getValueapp(wksBnsCur, matchPath);
            this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
        }
        // other datas
        if (otherDatasValues.length > 0) {
            const otherDatas = JSON.parse(wksBnsCur.bsnOtherdatas);
            for (const matchPath of otherDatasValues) {
                const value = this.getValueapp(otherDatas, matchPath);
                this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
            }
        }
        // bsnPerson
        if (personValues.length > 0 && wksBnsCur.bsnType === 'person') {
            const bsnPerson = JSON.parse(wksBnsCur.bsnPerson);
            if (bsnPerson.identity !== undefined && bsnPerson.identity !== null) {
                bsnAddress = bsnPerson.address;
                bsnEmails = bsnPerson.emails;
                bsnPhones = bsnPerson.phones;
                for (const matchPath of personValues) {
                    const value = this.getValueapp(bsnPerson.identity, matchPath);
                    this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
                }
            }
        }
        // bsnCompany
        if (companyValues.length > 0 && (wksBnsCur.bsnType === 'company' || wksBnsCur.bsnType === 'administration')) {
            // suppress identify person for admin or company      
            if (personValues.length > 0) {
                let identityTmp = {
                    cntCivility: '',
                    cntFirstname: '',
                    cntLastname: ''
                };
                if (wksBnsCur.dataContacts !== undefined && wksBnsCur.dataContacts.length > 0) {
                    const dataContact = wksBnsCur.dataContacts[0];
                    identityTmp = {
                        cntCivility: dataContact.cntCivility,
                        cntFirstname: dataContact.cntFirstname,
                        cntLastname: dataContact.cntLastname
                    };
                }
                for (const matchPath of personValues) {
                    const value = this.getValueapp(identityTmp, matchPath);
                    this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
                }
            }
            const bsnCompany = JSON.parse(wksBnsCur.bsnCompany);
            if (bsnCompany !== undefined && bsnCompany !== null) {
                bsnAddress = bsnCompany.address;
                bsnEmails = bsnCompany.emails;
                bsnPhones = bsnCompany.phones;
                for (const matchPath of companyValues) {
                    const value = this.getValueapp(bsnCompany, matchPath);
                    this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
                }
            }
        }
        // Address
        if (addressValues.length > 0 && bsnAddress !== undefined) {
            for (const matchPath of addressValues) {
                const value = this.getValueapp(bsnAddress, matchPath);
                this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
            }
        }
        // emails
        if (emailsValues.length > 0 && emailsValues !== undefined) {
            for (const matchPath of emailsValues) {
                const value = this.getValueapp(bsnEmails, matchPath);
                this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
            }
        }
        // phones
        if (phonesValues.length > 0 && phonesValues !== undefined) {
            for (const matchPath of phonesValues) {
                const value = this.getValueapp(bsnPhones, matchPath);
                this.affectToolKeyValue(matchPath.apiKey, value, toolArgs);
            }
        }
    }
    getValueapp(objectData, matchPath) {
        if (objectData === undefined) {
            return undefined;
        }
        const stringArray = matchPath.appValue.split('.');
        if (matchPath.appArray.position !== undefined) {
            const arrayValues = objectData;
            let arrayData;
            if (matchPath.appArray.position !== '-1') {
                arrayData = arrayValues[Number(matchPath.appArray.position)];
            }
            else {
                const conditionData = matchPath.appArray.condition;
                let matchValueArray;
                let matchItemArray;
                let isEqual, isNotEqual;
                if (conditionData.indexOf('!=') !== -1) {
                    const currentArray = conditionData.split('!=');
                    matchItemArray = currentArray[0].trim();
                    matchValueArray = currentArray[1].trim();
                    isNotEqual = true;
                    isEqual = false;
                }
                if (conditionData.indexOf('==') !== -1) {
                    const currentArray = conditionData.split('==');
                    matchItemArray = currentArray[0].trim();
                    matchValueArray = currentArray[1].trim();
                    isEqual = true;
                    isNotEqual = false;
                }
                let arrayTmpValue;
                for (const arrayItemCur of arrayValues) {
                    arrayData = arrayItemCur;
                    arrayTmpValue = CommonMethods.getValueSafe(arrayData, matchItemArray);
                    if (isEqual) {
                        if (arrayTmpValue === matchValueArray) {
                            break;
                        }
                        else {
                            arrayData = undefined;
                        }
                    }
                    if (isNotEqual) {
                        if (arrayTmpValue !== matchValueArray) {
                            break;
                        }
                        else {
                            arrayData = undefined;
                        }
                    }
                }
            }
            objectData = arrayData;
        }
        let appValue;
        if (matchPath.appConditional !== undefined && matchPath.appConditional.expectedValue !== undefined) {
            let matchItem = stringArray[stringArray.length - 1];
            const dataValue = CommonMethods.getValueSafe(objectData, matchItem);
            if (dataValue === matchPath.appConditional.expectedValue) {
                if (matchPath.appConditional.returnedValue) {
                    appValue = matchPath.appConditional.returnedValue;
                }
                if (matchPath.appConditional.returnedField) {
                    const stringArray1 = matchPath.appValue.split('.');
                    matchItem = stringArray1[stringArray.length - 1];
                    appValue = CommonMethods.getValueSafe(objectData, matchItem);
                }
            }
        }
        else {
            const matchItem = stringArray[stringArray.length - 1];
            appValue = CommonMethods.getValueSafe(objectData, matchItem);
        }
        return appValue;
    }
    affectToolKeyValue(keyArg, valueArg, toolArgs) {
        let toolKeyValue;
        let jsonTmp;
        toolKeyValue = {
            key: keyArg,
            value: valueArg,
            listValues: undefined,
            arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
    }
    affectResponseCustomer(toolApiResponse) {
        const toolApiDatasReturn = {
            // datas: ToolApiReturn[];
            datas: []
        };
        // const itemResponse = toolApiResponse.toolDatas[0];
        let itemValue = '';
        for (const itemCur of toolApiResponse.toolDatas) {
            if (itemCur === null) {
                continue;
            }
            if (itemCur.key === 'nws_externalId') {
                itemValue = itemCur.value;
                const toolApiReturn = {
                    dataName: 'nws_externalId',
                    dataValue: itemValue
                };
                toolApiDatasReturn.datas.push(toolApiReturn);
            }
            if (itemCur.key === 'statutCode') {
                itemValue = itemCur.value;
                const toolApiReturn = {
                    dataName: 'statutCode',
                    dataValue: itemValue
                };
                toolApiDatasReturn.datas.push(toolApiReturn);
            }
        }
        return toolApiDatasReturn;
    }
    requestApis(stdEntity, apiName, serviceName, toolTestArgs) {
        const urlCur = `${environment.baseUrl}/wks/wksentity/requestApis/?` + 'stdEntity=' + stdEntity + '&apiName=' + apiName + '&serviceName=' + serviceName;
        const body = JSON.stringify(toolTestArgs);
        return this.httpClient
            .post(urlCur, body, {
            headers: this.httpHeaders,
            observe: 'response',
        })
            .pipe(catchError(err => {
            // console.log(err.status);
            return observableThrowError(err);
        }));
    }
}
WksApisService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WksApisService_Factory() { return new WksApisService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.WksCentralService)); }, token: WksApisService, providedIn: "root" });
